import { render } from "./StaffPage.vue?vue&type=template&id=00ffed6a&scoped=true"
import script from "./StaffPage.vue?vue&type=script&lang=js"
export * from "./StaffPage.vue?vue&type=script&lang=js"

import "./StaffPage.vue?vue&type=style&index=0&id=00ffed6a&lang=css"
import "./StaffPage.vue?vue&type=style&index=1&id=00ffed6a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ffed6a"]])

export default __exports__